import(/* webpackMode: "eager", webpackExports: ["ProvidersGrid"] */ "/opt/hotlistcasino/frontend/src/app/[lang]/game-providers/ProvidersGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Breadcrumbs"] */ "/opt/hotlistcasino/frontend/src/components/Breadcrumbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MotionReveal"] */ "/opt/hotlistcasino/frontend/src/components/MotionReveal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MotionStagger"] */ "/opt/hotlistcasino/frontend/src/components/MotionStagger.tsx");
